import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { hotlineClientContactCompleteViewStyle } from '@/feature/hotline/client/detail/contact/complete/page/style';
import { HotlineClientContactDescription } from '@/feature/hotline/client/detail/contact/component/HotlineClientContactDescription';
import { HotlineCompleteLayout } from '@/feature/hotline/component/HotlineCompleteLayout';
import { pagePath } from '@/utils/router/pagePath';
/**
 * 匿名ホットライン今後の進め方 完了（View 部分のみ）
 */
export const HotlineClientContactCompleteView = (props) => {
    const { id, title } = props;
    const style = hotlineClientContactCompleteViewStyle();
    const breadcrumbs = [
        { link: pagePath.mypage.client.hotline(), text: 'マイページ' },
        { link: pagePath.hotline.client.detailNegotiate(id), text: title },
        { text: '相談申し込み完了' },
    ];
    return (_jsx(HotlineCompleteLayout, Object.assign({ breadcrumbs: breadcrumbs, classNames: { childrenWrap: style.contentWrap() }, links: [{ text: 'マイページへ', to: pagePath.mypage.client.hotline() }], pageTitle: title, sectionLeadSentence: _jsxs(_Fragment, { children: ["\u76F8\u8AC7\u306E\u6295\u7A3F\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002", _jsx("br", {}), "PROFFIT\u304B\u3089\u306E\u8FD4\u4FE1\u3092\u304A\u5F85\u3061\u304F\u3060\u3055\u3044\u3002"] }), sectionTitle: 'ご相談ありがとうございます' }, { children: _jsx(HotlineClientContactDescription, {}) })));
};
